import axios from 'axios';
import { Product } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

// Create axios instance with auth token
const createApiInstance = () => {
  const token = localStorage.getItem('token');
  return axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });
};

export const productAPI = {
  // Create a new product
  createProduct: async (product: Partial<Product>): Promise<Product> => {
    const api = createApiInstance();
    const response = await api.post('/products', product);
    return response.data;
  },

  // Get product by ID
  getProductById: async (productId: string): Promise<Product> => {
    const api = createApiInstance();
    const response = await api.get(`/products/${productId}`);
    return response.data;
  },

  // Get all products for a company
  getProductsByCompany: async (companyId: string): Promise<Product[]> => {
    const api = createApiInstance();
    const response = await api.get(`/products/company/${companyId}`);
    return response.data;
  },

  // Get products by category
  getProductsByCategory: async (categoryId: string): Promise<Product[]> => {
    const api = createApiInstance();
    const response = await api.get(`/products/category/${categoryId}`);
    return response.data;
  },

  // Update an existing product
  updateProduct: async (productId: string, product: Partial<Product>): Promise<Product> => {
    const api = createApiInstance();
    const response = await api.put(`/products/${productId}`, product);
    return response.data;
  },

  // Delete a product
  deleteProduct: async (productId: string): Promise<void> => {
    const api = createApiInstance();
    await api.delete(`/products/${productId}`);
  },
};
